<template>
  <div class="form-card form-card--bare">
    <div class="form-card__body">
      <form @submit.prevent="saveRole">
        <div class="row">
          <div class="col-md-6">
            <div class="form-card__field">
              <label class="form-card__label" for="role-name">Nombre</label>
              <input
                id="role-name"
                v-model.trim="role.name"
                type="text"
                class="form-control"
                placeholder="Nombre del rol"
                required
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-card__field">
              <label class="form-card__label" for="role-description">Descripción</label>
              <input
                id="role-description"
                v-model.trim="role.description"
                type="text"
                class="form-control"
                placeholder="Descripción del rol"
                required
              />
            </div>
          </div>
        </div>

        <div class="form-card__section mt-3">
          <label class="form-card__label">Puede acceder a</label>
          <div class="row">
            <div
              v-for="permission in permissionsList"
              :key="permission.id"
              class="col-md-6 mb-1 d-flex justify-content-start"
            >
              <label :for="`permiso-${permission.id}`" class="d-inline-flex align-items-center mb-0">
                <input
                  :id="`permiso-${permission.id}`"
                  v-model="role.allowed"
                  :value="permission.id"
                  type="checkbox"
                  class="mr-2"
                />
                {{ permission.description }}
              </label>
            </div>
          </div>
          <div v-if="!permissionsList || permissionsList.length === 0" class="form-card__hint">
            No hay permisos disponibles
          </div>
        </div>
      </form>
    </div>

    <div class="form-card__footer">
      <button type="button" class="form-card__btn" @click="$emit('close')">Cancelar</button>
      <button type="button" class="form-card__btn form-card__btn--primary" :disabled="isSaving" @click="saveRole()">
        <i class="bi bi-check-lg"></i>
        {{ role.id ? 'Modificar rol' : 'Guardar rol' }}
      </button>
    </div>
  </div>
</template>

<script>

export default {
  props: ['roleId', 'permissionsList'],
  mounted() {
    if (this.roleId != null) {
      this.getRole(this.roleId);
    } else {
      this.resetForm();
    }
  },
  data() {
    return {
      modo: 'nuevo',
      isSaving: false,
      role: {
        name: '',
        description: '',
        allowed: [],
      },
      emptyRole: {
        name: '',
        description: '',
        allowed: [],
      },
    }
  },
  watch: {
    roleId: function(value) {
      if (value != null) {
        this.getRole(value);
      } else {
        this.resetForm();
      }            
    }
  },
  methods: {
    saveRole() {
      if (this.isSaving) return;
      this.isSaving = true;
      var vm = this;
      if (vm.role.id != null) {
        vm.$http
          .post(`/api/configs/role/update/${vm.role.id}`, this.role)
          .then(() => {

            vm.resetForm();
            vm.$emit("confirmsave");
          })
          .finally(() => {
            vm.isSaving = false;
          });
      } else {
        this.$http
          .post("/api/configs/role/add", this.role)
          .then(() => {

            vm.resetForm();
            vm.$emit("confirmsave");
          })
          .finally(() => {
            vm.isSaving = false;
          });
      }
    },
    getRole(id) {
      var vm = this;
      this.modo = "editar";
      this.$http.get(`/api/configs/role/permissions/list/${id}`)
      .then((response) => {
        const { id, description, name, permissions } = response.data.data;
        const allowed = permissions.map(perm => perm.id);
        vm.role = { id, description, name, allowed };
      });
    },
    resetForm() {
      this.role = Object.assign({}, this.emptyRole);
    },
  },
}

</script>